import { render, staticRenderFns } from "./AppDownloadSection.vue?vue&type=template&id=50fa3ee7&scoped=true&"
import script from "./AppDownloadSection.vue?vue&type=script&lang=js&"
export * from "./AppDownloadSection.vue?vue&type=script&lang=js&"
import style0 from "./AppDownloadSection.vue?vue&type=style&index=0&id=50fa3ee7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fa3ee7",
  null
  
)

export default component.exports